import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable()
export class FormUtilsService {
  hasValue(form: FormGroup, controlName: string): boolean {
    const control = form.get(controlName);
    if (!control) return false;
    const value = control.value;
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    return !!value;
  }

  hasAnyValue(form: FormGroup): boolean {
    return Object.keys(form.controls).some((controlName) => {
      const control = form.get(controlName);
      return (
        control &&
        (Array.isArray(control.value)
          ? control.value.length > 0
          : !!control.value)
      );
    });
  }

  initializeFormValues(form: FormGroup) {
    return form.getRawValue();
  }

  isFormChanged(form: FormGroup, initialValues: unknown | null): boolean {
    return JSON.stringify(form.getRawValue()) !== JSON.stringify(initialValues);
  }

  resetForm(form: FormGroup, initialValues: unknown | null): void {
    if (this.isFormChanged(form, initialValues)) {
      form.reset(initialValues);
    }
  }
}
